import React from 'react';

import DropDown from '../DropDown';
import SelectGroup from '../SelectGroup';
import './WidgetSettings.scss';
import DurationGroup from '../DurationGroup';
import reducerStore from '../../../reducers/reducerStore';

const renderSetting = (setting, props) => {
	const { reportTypes, widget, setWidgetFieldValueWrapper, dividers } = props;

	switch (setting) {
		case 'widgetShows':
		case 'widgetDate': {
			return (<DropDown
				field={'dataType'}
				options={reportTypes[widget.widgetType]}
				setWidgetFieldValue={setWidgetFieldValueWrapper}
				widget={widget}
			/>);
		}
		case 'salePhase': {
			return (<SelectGroup
				title='Faser'
				label='name'
				endpoint='orderstage?type=order'
				group=''
				field='dataConfig.stage.stages'
				setWidgetFieldValue={setWidgetFieldValueWrapper}
				widget={widget}
				placeholder="Samtliga"
			/>);
		}
		case 'products': {
			return (<SelectGroup
				title='Produkter'
				label='name'
				endpoint='product'
				group='category.name'
				field='dataConfig.products'
				setWidgetFieldValue={setWidgetFieldValueWrapper}
				widget={widget}
				placeholder='Samtliga'
			/>);
		}
		case 'activities': {
			return (<SelectGroup
				title='Aktivitetstyper'
				label='name'
				endpoint='activityTypes/activity'
				group='category.name'
				field='dataConfig.appointment.types'
				setWidgetFieldValue={setWidgetFieldValueWrapper}
				widget={widget}
				placeholder='Samtliga'
			/>);
		}
		case 'users': {
			return (
				<SelectGroup
					title="Användare"
					label="name"
					placeholder="Samtliga"
					endpoint="user"
					group="role.name"
					field="user"
					setWidgetFieldValue={setWidgetFieldValueWrapper}
					widget={widget}
				/>
			);
		}
		case 'appointment': {
			return (<SelectGroup
				title='Aktivitetstyper'
				label='name'
				endpoint='activityTypes/appointment'
				group='category.name'
				field='dataConfig.appointment.types'
				setWidgetFieldValue={setWidgetFieldValueWrapper}
				widget={widget}
				placeholder='Samtliga'
			/>);
		}
		case 'grouping': {
			return (<DropDown
				setWidgetFieldValue={setWidgetFieldValueWrapper}
				field={'dataConfig.dividedBy'}
				options={dividers}
				widget={widget}
			/>);
		}
		case 'opportunityPhase': {
			return (<SelectGroup
				title='Faser'
				label='name'
				endpoint='orderstage?type=opportunity'
				group=''
				field='dataConfig.stage.stages'
				placeholder='Samtliga'
				setWidgetFieldValue={setWidgetFieldValueWrapper}
				widget={widget}
			/>);
		}
		case 'forms': {
			return (<SelectGroup
				title='Formulär'
				label='name'
				endpoint='forms'
				field='dataConfig.form.ids'
				group=''
				placeholder='Samtliga'
				setWidgetFieldValue={setWidgetFieldValueWrapper}
				widget={widget}
			/>);
		}
		case 'visitPages': {
			return (<SelectGroup
				title='Sidor'
				label='name'
				endpoint='pages'
				field='dataConfig.visit.pages'
				group=''
				placeholder='Samtliga'
				setWidgetFieldValue={setWidgetFieldValueWrapper}
				widget={widget}
			/>);
		}
		case 'campaigns': {
			return (<SelectGroup
				title='Kampanjer'
				label='subject'
				endpoint='campaigns'
				field='dataConfig.campaigns'
				group=''
				placeholder='Samtliga'
				setWidgetFieldValue={setWidgetFieldValueWrapper}
				widget={widget}
			/>);
		}
		case 'name': {
			return (<input
				placeholder={'Contest Name'}
				value={setContestInputsValue(widget, 'contest-name')}
				type='text'
				className='input'
				onChange={event => {
					reducerStore.dispatch({ type: 'SET_COMPETITION_DATA', property: 'name', value: event.target.value, slideId: widget.id });
				}}
			/>);
		}
		case 'goals': {
			return (<div className='settings-wrapper'>
				<input
					placeholder={'1000'}
					value={setContestInputsValue(widget, 'contest-goals')}
					type='number'
					className='input'
					onChange={event => {
						reducerStore.dispatch({ type: 'SET_COMPETITION_DATA', property: 'goals', value: event.target.value, slideId: widget.id });
					}}
				/>
				<div className='points-label'>Points</div>
			</div>
			);
		}
		case 'duration': {
			return (<DurationGroup
				widget={widget}
				onChange={(field, value) => {
					reducerStore.dispatch({ type: 'SET_COMPETITION_DATA', property: field, value: value, slideId: widget.id })
				}}
			/>);
		}
	}
}

const setContestInputsValue = (widget, name) => {
	if (widget.competitionSettings) {
		if (name === 'contest-name') {
			return widget.competitionSettings.name;
		} else if (name === 'contest-goals') {
			return widget.competitionSettings.goals;
		}
	}
}

const titleMap = {
	widgetDate: 'Vilket datum ska användas?',
	widgetShows: 'Widgeten visar',
	salePhase: 'Faser',
	opportunityPhase: 'Faser',
	activities: 'Aktivitetstyper',
	appointment: 'Mötesyper',
	products: 'Produkter',
	grouping: 'Gruppera',
	forms: 'Formulär',
	visitPages: 'Inkluderade sidor',
	campaigns: 'Massutskick',
	name: 'Tävlingsnamn',
	goals: 'Tävlingsmål',
	duration: 'Tävlingstid',
	users: 'Användare',
};

const WidgetSettings = (props) => {
	const { reportTypes, widget } = props;

	const widgetType = _.find(_.get(reportTypes, [widget.widgetType]), { value: widget.dataType });
	return (
		<div>
			{_.map(widgetType.settings, (setting, index) => {
				return (
					<div className="col-100-percent" key={`setting-component-${index}-${setting}`}>
						<div className="helper">
							<span className="title">{titleMap[setting]}</span>
							<div>
								{renderSetting(setting, props)}
							</div>
						</div>
					</div>
				)
			})}
		</div>
	)
};

WidgetSettings.propTypes = {
	widget: React.PropTypes.object,
	reportTypes: React.PropTypes.object,
	setWidgetFieldValueWrapper: React.PropTypes.func,
	// onClick: React.PropTypes.func, 
	// active: React.PropTypes.bool, 
};

export default WidgetSettings; 


/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/WidgetSettings/WidgetSettings.jsx
 **/